module.exports = __webpack_public_path__ + "img/blog.ca092ca0.svg";